import { unref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { t } from '@mts/hooks/web/useI18n';
import { REDIRECT_NAME } from '@/router/constant';
import { getLocaleStore, getUserStore } from '@/store';

/**
 * Listening to page changes and dynamically changing site titles
 */
export function useTitle() {
  const { currentRoute } = useRouter();
  const { platformTitle } = getUserStore().getProjectInfo;
  const localeStore = getLocaleStore();

  watch(
    [() => currentRoute.value.path, () => localeStore.getLocale],
    () => {
      const route = unref(currentRoute);

      if (route.name === REDIRECT_NAME) {
        return;
      }

      const tTitle = t(route?.meta?.title as string);
      document.title = tTitle ? ` ${tTitle} - ${platformTitle} ` : `${platformTitle}`;
    },
    { immediate: true },
  );
}
